import React, { useEffect, useState, useMemo } from "react";
import withRouter from "components/Common/withRouter";
import TableContainer from "components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import axios from "axios";
import moment from "moment";

const API_BASE = "https://mansethaberapi.stechomeyazilim.com";
const ODATA_NOTIFICATION_LOG = `${API_BASE}/BILDIRIM_LOGLARI?$format=json&$top=1000&$orderby=GONDERIM_TARIHI desc`;

const NotificationList = () => {
  document.title = "Gönderilen Bildirimler | Manşet Haber ADMIN PANELI";

  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const res = await fetch(ODATA_NOTIFICATION_LOG);
      const json = await res.json();
      if (json && json.value && Array.isArray(json.value)) {
        setNotifications(json.value);
      } else if (Array.isArray(json)) {
        setNotifications(json);
      } else {
        setNotifications([]);
      }
    } catch (error) {
      console.error("Bildirim verileri alınamadı:", error);
      setNotifications([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Bu bildirimi silmek istediğinize emin misiniz?")) return;
    try {
      await axios.delete(`${API_BASE}/BILDIRIM_LOGLARI(${id})`);
      fetchNotifications();
    } catch (error) {
      console.error("Silme hatası:", error);
      alert("Silme işlemi başarısız oldu.");
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: ({ row }) => <span>{row.index + 1}</span>,
      },
      {
        Header: "Görsel",
        accessor: "thumbnail_url",
        disableFilters: true,
        Cell: ({ value }) =>
          value ? (
            <img
              src={value}
              alt=""
              style={{ width: 48, height: 48, objectFit: "cover", borderRadius: 6 }}
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          ) : (
            <span className="text-muted">-</span>
          ),
      },
      {
        Header: "Kullanıcı ID",
        accessor: "KULLANICI_ID",
        Cell: ({ value }) => (
          value === 0 ? (
            <Badge color="secondary">Tümü</Badge>
          ) : (
            <span className="text-muted">{value}</span>
          )
        ),
      },
      {
        Header: "Başlık",
        accessor: "BASLIK",
        filterable: true,
      },
      {
        Header: "İçerik",
        accessor: "ICERIK",
        filterable: true,
        Cell: ({ value }) => (
          <span className="text-muted" style={{ maxWidth: 300, display: "inline-block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {value}
          </span>
        ),
      },
      {
        Header: "Tip",
        accessor: "TIP",
        Cell: ({ value }) => (
          <Badge color="info" className="font-size-11">
            {value || "Genel"}
          </Badge>
        ),
      },
      {
        Header: "Hedef Cihaz",
        accessor: "HEDEF_SAYISI",
        disableFilters: true,
        Cell: ({ value }) =>
          value != null && value !== "" ? (
            <Badge color="primary" className="font-size-11">
              {value}
            </Badge>
          ) : (
            <span className="text-muted">-</span>
          ),
      },
      {
        Header: "Okundu",
        accessor: "OKUNDU",
        Cell: ({ value }) =>
          value ? (
            <Badge color="success">Evet</Badge>
          ) : (
            <Badge color="warning">Hayır</Badge>
          ),
      },
      {
        Header: "Tarih",
        accessor: "GONDERIM_TARIHI",
        Cell: ({ value }) =>
          value ? moment(value).format("DD.MM.YYYY HH:mm") : "-",
      },
      {
        Header: "İşlemler",
        accessor: "actions",
        disableFilters: true,
        Cell: ({ row }) => (
          <button
            type="button"
            className="btn btn-sm btn-danger"
            onClick={() => handleDelete(row.original.ID || row.original.id)}
          >
            <i className="mdi mdi-delete font-size-14 me-1" />
            Sil
          </button>
        ),
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Gönderilen Bildirimler" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={notifications}
                    isGlobalFilter={true}
                    isAddUser={false}
                    customPageSize={10}
                    className="custom-header-css"
                  />
                  {loading && (
                    <div className="text-center mt-3">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Yükleniyor...</span>
                      </div>
                    </div>
                  )}
                  {!loading && notifications.length === 0 && (
                    <div className="text-center mt-4 text-muted">
                      Henüz gönderilen bildirim bulunmamaktadır.
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(NotificationList);
